import React, { useState } from 'react';
import './ImagePrompt.css';
import './PreviewScreen.css';
import './Imagenes/ejemplo1.png';
import eyeSVG from './Iconos/eye.svg';
import { useTranslation } from 'react-i18next';

const PreviewScreen: React.FC = () => {
    // Recuperar la imagen y el texto del localStorage
    const selectedImage = localStorage.getItem('selectedImage') ?? 'ejemplo1.png'; ;
    const textDataJSON = localStorage.getItem('textData');
    let generatedText = '';
    const { t } = useTranslation();

    if (textDataJSON) {
        const textData = JSON.parse(textDataJSON);
        generatedText = textData.content; // Extraemos solo el contenido del texto
    }
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleImageClick = () => {
        setIsModalOpen(true); // Abre el modal al hacer clic en la imagen
    };

    const handleCloseModal = () => {
        setIsModalOpen(false); // Cierra el modal al hacer clic fuera de la imagen
    };

    return (
        <div>
            <div className="preview-header">
               <img src={eyeSVG} alt="Vista previa" /> <h2>{t('Vista previa')}</h2>
            </div>
            <div className="preview-container">
                <div className="preview-content">
                    {selectedImage && (
                        <div className="preview-image-wrapper" onClick={handleImageClick}>
                            <img src={selectedImage} alt="Selected" className="preview-image" />
                        </div>
                    )}
                    {generatedText && (
                        <div className="preview-text">
                            <p>{generatedText}</p>
                        </div>
                    )}
                </div>
            </div>
            {isModalOpen && (
                <div className="modal-backdrop" onClick={handleCloseModal}>
                    <div className="modal-content">
                        <img src={selectedImage} alt="Ampliada" className="modal-image" />
                        <p className="modal-text">{generatedText}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PreviewScreen;
